import * as Actions from '../../actions';

const initialState = { data: null };

const listHaulerAssignmentReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_HAULER_ASSIGNMENT_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listHaulerAssignmentReducer;
